import React, {useCallback, useEffect, useRef, useState} from "react";
import {useHistory, useLocation} from "react-router-dom";
import {TRANSACTION_TYPES} from "../api/Constants";
import {submitAdhocFund} from "../api/RestCallHelper";
import AutocompleteTextInput, {DataType} from "../shared/AutocompleteTextInput";
import DatePicker from "../shared/DatePicker";
import TextInput from "../shared/TextInput";
import {validateForm} from "../utils/ValidationUtil";
import FormPage from "./baseFormPage/BaseFormPage";
import {FormButton} from "../styles/globalStyles";
import FormHeader from "../shared/FormHeader";
import {FeedbackReducerActionType, useFeedbackDispatch} from "../utils/FeedbackContext";
import useFetchTransactionTypes from "../hooks/useFetchTransactionTypes";
import ToggleButtonGroup from "../shared/ToggleButtonGroup";

export default function IncomeForm() {

    let location = useLocation();
    let history = useHistory();

    const dispatch = useFeedbackDispatch();

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [dropdownData, loading] = useFetchTransactionTypes(dropdownOpen);

    const [funds, setFunds] = useState({
        amount:"",
        eft:true,
        date: null,
        reason:"",
        transactionType:""
    });

  const [formValidated, setFormValidated] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const isMounted = useRef(true);

  const clear = () => {
    setFunds({
        amount:"",
        eft:true,
        date: null,
        reason:"",
        transactionType:""
    });
  }

    const close = (event, reason) => {
        console.log("In Investment close callback");
        if (reason === 'clickaway') return;

        dispatch({type: FeedbackReducerActionType.CLOSE_FEEDBACK});
    };

  useEffect(() => {
    setFormValidated(validateForm(funds));
    console.log("funds", funds);
  }, [funds, formValidated]);

  const submit = useCallback(async () => {

    // don't send again while we are sending
    if (isSending) return;

    // update state
    setIsSending(true);

    // send the actual request

    console.log("funds", funds);

    await submitAdhocFund(TRANSACTION_TYPES.INCOME, funds, dispatch, close, history, location);

    // once the request is sent, update state again
    if (isMounted.current) {
      // only update if we are still mounted
      setIsSending(false);
      clear();
    }

  }, [isSending, location, funds]); // update the callback if the state changes

  return (
    
    <FormPage

        header = {
          <FormHeader
              heading= "Record Incomes"
          />
        }

      form = { 
        <>
          <AutocompleteTextInput
            label = "Select Transaction Type"
            value = {funds.transactionType}
            onChange = {(value) => setFunds({...funds , transactionType: value})}
            optionsList = {dropdownData}
            loading = {loading}
            open = {dropdownOpen}
            setOpen = {setDropdownOpen}
            dataType = {DataType.TRANSACTION}
          />

          <DatePicker
              label="Date"
              value={funds.date}
              onChange={(value) => setFunds({ ...funds, date: value }) }
              style={{ margin: "10px" }}
          />

            <ToggleButtonGroup
                value={funds.eft}
                setValue= {(value) => (setFunds({...funds, eft: value}))}
                trueOption="EFT"
                falseOption="CASH"
            />

          <TextInput
              number
              label="Amount"
              value={funds.amount}
              onChange={(value) => setFunds({ ...funds, amount: value }) }
              style={{ margin: "10px" }}
          />

          <TextInput
            multiline
            label="Reason"
            value={funds.reason}
            onChange={(value) => setFunds({ ...funds, reason: value }) }
            style={{ margin: "10px" }}
          />
        </>

      }

      buttons = {
        <>
            {formValidated &&
                <FormButton
                    disabled={isSending}
                    onClick={submit}
                >
                    Submit
                </FormButton>   
            }

            <FormButton
                onClick={clear}
                disabled={isSending}
            >
                Clear
            </FormButton>
        </>
      }

    />
  );
}
